module.exports = function() {
  return new Worker(__webpack_public_path__ + "fc37ed67b86bf1cd4f03.worker.js");
};